export const vitalNames = ['cls', 'fcp', 'fid', 'lcp', 'ttfb', 'inp'];
